import { render, staticRenderFns } from "./task-skeleton.vue?vue&type=template&id=1723d6a3&scoped=true&lang=pug&"
import script from "./task-skeleton.vue?vue&type=script&lang=js&"
export * from "./task-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./task-skeleton.vue?vue&type=style&index=0&id=1723d6a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1723d6a3",
  null
  
)

export default component.exports